import { isDurationAvailable } from 'components/forms/TimePicker/utils';
import { EMPTY } from 'utils/atomUtils';
import { DomesticV2BoatsIdCalendarGet200Response } from 'swagger/models';
import type { UseFormMethods } from 'react-hook-form';
import { useAtom, useAtomValue } from 'jotai';
import {
  bookingDurationAtom,
  bookingTripTimeAtom,
  selectedBookingPackageAtom,
  tripStartFormattedAtom,
} from 'components/forms/bookingWidget/jotaiStore';
import { InputWrap, SimplifiedRHFErrors } from './shared';
import DurationPicker from './DurationPicker/DurationPicker';

interface ErrorWithDuration extends SimplifiedRHFErrors {
  duration?: {
    message: string;
  };
}

interface DurationInputProps {
  isModal: boolean;

  // errors here is a simplified interface for react-hook-form errors from the parent component.
  errors?: ErrorWithDuration;
  register: UseFormMethods['register'];

  boatCalendar: DomesticV2BoatsIdCalendarGet200Response;
}
export default ({ isModal, errors, register, boatCalendar }: DurationInputProps) => {
  const tripStartFormatted = useAtomValue(tripStartFormattedAtom);
  const [selectedBookingPackage] = useAtom(selectedBookingPackageAtom);
  const [tripTime, setTripTime] = useAtom(bookingTripTimeAtom);
  const [bookingDuration, setBookingDuration] = useAtom(bookingDurationAtom);

  return (
    <InputWrap noBorder={isModal}>
      <DurationPicker
        modalVersion={isModal}
        error={errors?.duration?.message}
        onChange={(duration) => {
          if (
            !isDurationAvailable(
              tripStartFormatted,
              boatCalendar,
              selectedBookingPackage?.package_type,
              tripTime?.value,
              duration.value
            )
          ) {
            setTripTime(EMPTY);
          }
        }}
        setter={setBookingDuration}
        defaultValue={bookingDuration}
      />
      <input type="hidden" ref={register({ required: 'Please select duration' })} name="duration" />
    </InputWrap>
  );
};
